var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6667 14.2844C9.6667 15.0336 8.90337 15.6669 8.00003 15.6669C7.0967 15.6669 6.33337 15.0336 6.33337 14.2844V14.0002H9.6667V14.2844ZM15.1009 11.6727L13.6 10.1702V6.4469C13.6 3.54607 11.515 1.08274 8.7492 0.716069C7.14837 0.503569 5.5317 0.991902 4.3192 2.05524C3.0992 3.12357 2.40004 4.66107 2.40004 6.27274L2.3992 10.1702L0.899202 11.6736C0.508369 12.0644 0.392535 12.6477 0.604202 13.1586C0.816702 13.6694 1.31087 14.0002 1.8642 14.0002H4.6667V14.2844C4.6667 15.9661 6.1617 17.3336 8.00003 17.3336C9.83837 17.3336 11.3334 15.9661 11.3334 14.2844V14.0002H14.135C14.6884 14.0002 15.1825 13.6702 15.3942 13.1586C15.6067 12.6477 15.4909 12.0644 15.1009 11.6727Z",
    fill: "#003353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBell);
export default __webpack_public_path__ + "static/media/DarkBell.0df7b8eb0077f0ad67844abe3f09fc07.svg";
export { ForwardRef as ReactComponent };